import React, { useEffect } from 'react'

import Hero from './Hero'
import Beneficios from './Beneficios'
import Topicos from './Topicos'
import Funcionamento from './Funcionamento'
import Planos from './Planos'
import Contatos from './Contatos'
import scrollUtils from '../../util/scroll'

export default function () {
	useEffect(() => {
		scrollUtils.toTop()
	}, [])

	return (
		<main>
			<Hero />
			<Topicos />
			<Beneficios />
			<Funcionamento />
			<Planos />
			<Contatos />
		</main>
	)
}
